import { StyledButtonHubstairs } from './styled'
import Link, { useLinkNavigateTo } from 'components/Router/Link'

/**
 * Doc react-hubstairs: https://pfdocs.hubstairs.com/front/react/components/button
 */
function Button({ href, navigateTo, ...props }) {
  const { to: linkTo, state: linkState } = useLinkNavigateTo({ to: href, navigateTo })
  return <StyledButtonHubstairs Link={Link} href={linkTo} linkState={linkState} {...props} />
}

function ButtonPlaceholder({ href, navigateTo, ...props }) {
  const { onClick, ...rest } = props
  return <StyledButtonHubstairs.Placeholder {...rest} />
}

Button.Placeholder = ButtonPlaceholder

export default Button
